<template>
  <main-page :user="user" color="orange">
    <template v-slot:title></template>
    <div class="container-fluid">
    <div class="col-sm-9 m-auto">
      <br />

      <div class="card-body col-12 col-sm-8 col-lg-6 m-auto">
        <h4 class="card-title">My Profile</h4>
        <div class="mt-4 left">
          <div v-if="user && user.name" class="form-group">
            <label for="exampleInputEmail1">First Name</label>
            <input type="text" v-model="user.name.first" class="form-control" />
          </div>
          <div v-if="user && user.name" class="form-group">
            <label for="exampleInputEmail1">Last Name</label>
            <input type="text" v-model="user.name.last" class="form-control" />
          </div>
          <div class="form-group">
            <label for="exampleInputEmail1">Email address</label>
            <input type="text" v-model="user.email" class="form-control" />
          </div>
          <div class="row">
            <div class="col-6 form-group ml-0">
              <button class="btn btn-info btn-block" @click="togglePass">
                Set Password
                <i
                  class="fas fa-angle-up fa-lg fa-fw"
                  :class="{ 'rotate-180': setPass }"
                ></i>
              </button>
            </div>
            <div class="col-6 form-group"></div>
          </div>
          <div v-show="setPass">
            <div class="p-2">
              <div class="form-group pl-2 pr-3">
                <label>Old Password</label>
                <input
                  type="password"
                  v-model="password"
                  class="form-control"
                />
              </div>
              <div class="form-group pl-2 pr-3">
                <label>New Password</label>
                <input
                  type="password"
                  v-model="password1"
                  class="form-control"
                  :class="{ 'has-danger': !checkPassword(password1) }"
                />
              </div>
              <div class="form-group pl-2 pr-3">
                <label>Confirm Password</label>
                <input
                  type="password"
                  v-model="password2"
                  class="form-control"
                  :class="{ 'has-danger': !checkMatch(password2) }"
                />
              </div>
              <div class="ml-2" style="min-height: 23px">
                <div
                  v-for="(error, i) in passwordErrors()"
                  :key="i"
                  class="text-danger"
                >
                  <i class="fas fa-exclamation-triangle mr-1" />
                  {{ error }}
                </div>
              </div>
            </div>
          </div>

          <div>
            <button
              v-if="
                setPass &&
                (passwordErrors().length > 0 || !password1 || !password2)
              "
              type="button"
              class="btn btn-primary float-right"
              disabled
            >
              Submit
            </button>
            <button
              v-if="
                !setPass ||
                (passwordErrors().length == 0 && password1 && password2)
              "
              type="button"
              class="btn btn-primary float-right"
              @click="saveandquit"
            >
              Submit
            </button>

            <a href="/#/portfolio" class="btn float-right">Cancel</a>
          </div>
        </div>
      </div>
    </div>
    </div>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import UserService from "@/services/UserService.js";
import AuthService from "@/services/AuthService.js";
import Notie from "@/services/NotieService";

export default {
  name: "UserAccountEdit",

  props: ["user"],

  components: { MainPage },

  data() {
    return {
      service: UserService,
      authsvc: AuthService,

      setPass: false,
      password: null,
      password1: null,
      password2: null,
    };
  },

  methods: {
    togglePass() {
      this.password1 = null;
      this.password2 = null;
      this.setPass = !this.setPass;
    },

    check_validity() {
      //check name
      if (
        !this.user.name.first ||
        this.user.name.first == "" ||
        !this.user.name.last ||
        this.user.name.last == ""
      ) {
        Notie.error("First and Last Name required");
        return false;
      }

      //check email
      if (!this.user.email.match(/.+@.+\..+/)) {
        Notie.error("Valid email required");
        return false;
      }

      return true;
    },

    save(callback) {
      if (this.setPass) {
        this.setPassword();
      }
      if (this.check_validity()) {
        this.service
          .setUserAccount(this.user)
          .then(() => {
            Notie.success("Saved!");
            callback();
            return true;
          })
          .catch((err) => {
            if (err.response.status == 409) {
              Notie.error("Email already in use");
            } else {
              alert(err);
            }
            return false;
          });
      } else {
        return false;
      }
    },

    saveandquit() {
      this.save(() => {
        console.log("success")
        this.$router.push("/portfolio");
      });
    },

    checkPasswordLen(pass) {
      if (!pass) {
        return true;
      }
      return pass.length >= 8 && pass.length <= 16;
    },

    checkPasswordChars(pass) {
      if (!pass) {
        return true;
      }
      return (
        pass.match(/.*[A-Z].*/) &&
        pass.match(/.*[a-z].*/) &&
        pass.match(/.*[0-9].*/)
      );
    },

    checkPassword(pass) {
      return this.checkPasswordLen(pass) && this.checkPasswordChars(pass);
    },

    checkMatch(pass1, pass2) {
      if (pass1 && pass2) {
        if (pass1 != pass2) {
          return false;
        }
      }
      return true;
    },

    passwordErrors() {
      var errs = [];
      if (!this.checkPasswordChars(this.password1)) {
        errs.push(
          "Must include at least one lowercase (a-z), at least one uppercase (A-Z), and at least one digit (0-9)"
        );
      }
      if (!this.checkPasswordLen(this.password1)) {
        errs.push("Password must be between 8 and 16 characters");
      }
      if (!this.checkMatch(this.password1, this.password2)) {
        errs.push("Passwords must match");
      }
      return errs;
    },

    setPassword() {
      this.authsvc
        .login(this.user.email, this.password)
        .then(() => {
          if (this.passwordErrors().length == 0) {
            this.service
              .setUserPassword(this.user.id, this.password1.toString())
              .then(() => {
                Notie.success("Password set");
                this.$bvModal.hide("setPasswordModal");
              })
              .catch((e) => {
                console.log(e);
                Notie.error("Failed to set password", e);
              });
          } else {
            Notie.error("Failed to set password", 0);
          }
        })
        .catch(() => {
          Notie.error("Old password is incorrect");
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.has-danger {
  border-color: #e46a76;
}
.left {
  text-align: left;
}
</style>

